import { adminApi } from '~/api'
import { useMutation } from '@tanstack/react-query'

export const useCreateUserMutation = () => {
  return useMutation((values) => {
    return adminApi.createUser(values)
  })
}
